
	import ModeloCadastro from '@/views/paginas/sigap/modelos/ModeloCadastro.vue';   
    import { Options   } from "vue-class-component";   
    import {  Configuracao } from "./Configuracao";
	import $ from "jquery" 
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
	  
    @Options({
        name: "ConfiguracaoCadastro",
        components: {   },  
        emits: [  'configuracao-cadastrado'],  
    }) 
    export default class ConfiguracaoCadastro extends ModeloCadastro {
        
        created() {  
            this.campos =  Configuracao.campos();  
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
   
        public getdados(){   
            let dados = JSON.parse(JSON.stringify(this.formulario));  
            return dados;
        }
 
        public sucesso(){  
            this.$emit("configuracao-cadastrado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }
    } 
